import React from 'react'
import { MessageDescriptor } from 'react-intl'
import { PrimitiveType } from 'intl-messageformat'

import classNames from 'classnames'
import { Head } from '../shared/Head'
import { Footer } from '../shared/Footer'
import { LogoCenter, LogoLeft } from '../../shared/logo'
import styles from './GuestLayout.module.css'

type GuestLayoutProps = {
  title: {
    messageDescriptor: MessageDescriptor
    values?: Record<string, PrimitiveType>
  }
}

const GuestLayout: React.FC<GuestLayoutProps> = ({ children, title }) => {
  return (
    <>
      <Head title={title} />
      <div
        className={classNames(
          styles.background,
          'min-h-screen flex flex-col md:flex-row md:justify-start md:items-center'
        )}
      >
        <div className="flex flex-1 flex-col md:w-xl md:flex-initial md:rounded-r-lg md:bg-white md:shadow-lg">
          <header className="my-8 flex flex-1 flex-col justify-center px-2 md:px-6">
            <LogoCenter className="block md:hidden" />
            <LogoLeft className="hidden md:block" />
          </header>
          <div className="rounded-t-lg bg-primary-500 px-2 md:rounded-l-none md:rounded-r-lg md:px-6">
            <main className="mb-32 mt-12">{children}</main>
            <Footer className="my-4" />
          </div>
        </div>
      </div>
    </>
  )
}

export { GuestLayout }
